const routeList = [
  {
    path: "/",
    name: "home",
    meta: {
      title: '室内新游乐典范'
    },
    component: () => import('@view/web/index/index.vue')
  },
  {
    path: "/about/:tab?",
    name: "about",
    meta: {
      title: '关于我们'
    },
    component: () => import('@view/web/about/index.vue')
  },
  {
    path: "/news/:tab?",
    name: "news",
    meta: {
      title: '新闻中心'
    },
    component: () => import('@view/web/news/index.vue')
  },
  {
    path: "/detail",
    name: "newsDetail",
    meta: {
      title: ''
    },
    component: () => import('@view/web/news/detail.vue')
  },
  {
    path: "/brand/:tab?",
    name: "brand",
    meta: {
      title: '旗下品牌'
    },
    component: () => import('@view/web/brand/index.vue')
  },
  {
    path: "/ecological/:tab?",
    name: "ecological",
    meta: {
      title: 'IP生态'
    },
    component: () => import('@view/web/ecological/index.vue')
  },
  {
    path: "/training/:tab?",
    name: "training",
    meta: {
      title: '培训学院'
    },
    component: () => import('@view/web/training/index.vue')
  },
  {
    path: "/coo/:tab?",
    name: "coo",
    meta: {
      title: '合作联系'
    },
    component: () => import('@view/web/coo/index.vue')
  },
  {
    path: "/search",
    name: "search",
    meta: {
      title: ''
    },
    component: () => import('@view/web/search/index.vue')
  },
]

export default routeList
